module.exports = __webpack_public_path__ + "static/media/logo.ea5ece07.svg";